import React from 'react';
import { RenderEditTable, RenderShowTable } from './table';
import { useToggleSwitch } from './toggleSwitch';

/**
 * グループユーザ表示部分
 * @param {AppendableUsers} appendableUsers グループに追加可能なユーザーに表示するユーザーデータ
 * @param {AssignUsers} assignUsers グループに追加するユーザーに表示するユーザーデータ
 * @param {function} setLeftMovedUserIds 左側に移動済みのユーザーを変更する関数
 * @param {function} setRightMovedUserIds 右側に移動済みのユーザーを変更する関数
 **/
function RenderGroupUserDisplay({
  appendableUsers,
  assignUsers,
  isSso,
  setLeftMovedUserIds,
  setRightMovedUserIds,
}) {
  const [
    { rightMoveScheduledUserIds, leftMoveScheduledUserIds },
    {
      setRightMoveScheduledUserIds,
      setLeftMoveScheduledUserIds,
      RenderToggleSwitch,
    },
  ] = useToggleSwitch(setLeftMovedUserIds, setRightMovedUserIds);
  return (
    <RenderDualTablePanel
      leftPanelTitle='グループに追加しないユーザー'
      rightPanelTitle='グループに追加するユーザー'
      leftPanelDescription=''
      rightPanelDescription=''
      renderLeftTable={
        <RenderEditTable
          lwUsers={appendableUsers}
          isSso={isSso}
          checkedUserIds={rightMoveScheduledUserIds} //チェックしたユーザー=移動予約したユーザー
          setCheckedUserIds={setRightMoveScheduledUserIds}
        />
      }
      renderRightTable={
        <RenderEditTable
          lwUsers={assignUsers}
          isSso={isSso}
          checkedUserIds={leftMoveScheduledUserIds}
          setCheckedUserIds={setLeftMoveScheduledUserIds}
        />
      }
      renderToggleSwitch={<RenderToggleSwitch />}
    />
  );
}

/**
 * トークルーム登録ユーザ表示部分
 * @param {AppendableUsers} appendableUsers トークルームに追加可能なユーザーに表示するユーザーデータ
 * @param {AssignUsers} assignUsers トークルームに追加するユーザーに表示するユーザーデータ
 * @param {function} setLeftMovedUserIds 左側に移動済みのユーザーを変更する関数
 * @param {function} setRightMovedUserIds 右側に移動済みのユーザーを変更する関数
 **/
function RenderTalkroomRegisterUserDisplay({
  appendableUsers,
  assignUsers,
  setLeftMovedUserIds,
  setRightMovedUserIds,
}) {
  const [
    { rightMoveScheduledUserIds, leftMoveScheduledUserIds },
    {
      setRightMoveScheduledUserIds,
      setLeftMoveScheduledUserIds,
      RenderToggleSwitch,
    },
  ] = useToggleSwitch(setLeftMovedUserIds, setRightMovedUserIds);

  return (
    <RenderDualTablePanel
      leftPanelTitle='トークルームに追加しないユーザー'
      rightPanelTitle='トークルームに追加するユーザー'
      leftPanelDescription=''
      rightPanelDescription=''
      renderLeftTable={
        <RenderEditTable
          lwUsers={appendableUsers}
          checkedUserIds={rightMoveScheduledUserIds} //チェックしたユーザー=移動予約したユーザー
          setCheckedUserIds={setRightMoveScheduledUserIds}
        />
      }
      renderRightTable={
        <RenderEditTable
          lwUsers={assignUsers}
          checkedUserIds={leftMoveScheduledUserIds}
          setCheckedUserIds={setLeftMoveScheduledUserIds}
        />
      }
      renderToggleSwitch={<RenderToggleSwitch />}
    />
  );
}

/**
 * トークルーム登録済みユーザ表示部分
 * @param {ShowUsers} showUsers 表示するユーザーデータ
 **/
function RenderTalkroomShowUserDisplay({ showUsers }) {
  return (
    <RenderSingleTablePanel
      panelTitle='トークルーム内のユーザー'
      panelDescription=''
      renderTable={<RenderShowTable lwUsers={showUsers} />}
    />
  );
}

/**
 * 1種類のテーブルを表示するパネル
 * @param {string} panelTitle タイトル
 * @param {string} panelDescription 説明文
 * @param {HTMLElement} renderTable テーブル
 **/
function RenderSingleTablePanel({ panelTitle, panelDescription, renderTable }) {
  return (
    <div className='dual-panel'>
      <div className='dual-panel__item'>
        <div className='panel'>
          <div className='panel-header'>
            <div className='panel-title'>{panelTitle}</div>
          </div>
          <div className='panel-list lw-user-manage-table'>{renderTable}</div>
          <div className='panel-description'>{panelDescription}</div>
        </div>
      </div>
    </div>
  );
}

/**
 * 2種類のテーブルを表示するパネル
 * @param {string} leftPanelTitle 左側のタイトル
 * @param {string} rightPanelTitle 右側のタイトル
 * @param {string} leftPanelDescription 左側の説明文
 * @param {string} rightPanelDescription 右側の説明文
 * @param {HTMLElement} renderLeftTable 左側のテーブル
 * @param {HTMLElement} renderRightTable 左側のテーブル
 * @param {HTMLElement} renderToggleSwitch トグルスイッチ
 **/
function RenderDualTablePanel({
  leftPanelTitle,
  rightPanelTitle,
  leftPanelDescription,
  rightPanelDescription,
  renderLeftTable,
  renderRightTable,
  renderToggleSwitch,
}) {
  return (
    <div className='dual-panel'>
      <div className='dual-panel__item'>
        <div className='panel'>
          <div className='panel-header'>
            <div className='panel-title'>{leftPanelTitle}</div>
          </div>
          <div className='panel-list lw-user-manage-table'>
            {renderLeftTable}
          </div>
          <div className='panel-description'>{leftPanelDescription}</div>
        </div>
      </div>
      {renderToggleSwitch}
      <div className='dual-panel__item'>
        <div className='panel'>
          <div className='panel-header'>
            <div className='panel-title'>{rightPanelTitle}</div>
          </div>
          <div className='panel-list lw-user-manage-table'>
            {renderRightTable}
          </div>
          <div className='panel-description'>{rightPanelDescription}</div>
        </div>
      </div>
    </div>
  );
}

export {
  RenderGroupUserDisplay,
  RenderTalkroomRegisterUserDisplay,
  RenderTalkroomShowUserDisplay,
};



// WEBPACK FOOTER //
// ./src/components/lwUser/usersDisplay.jsx